<template>
	<div class = "box">
		<ComNar title = "个人中心"></ComNar>
		<Card></Card>
		<div class = "user-info-div">
			<van-field center clearable type="digit" label="手机号" :disabled="hasPhone()" placeholder="您未绑定手机号" v-model="phone">
			 <template #button>
			    <van-button v-if="!showVerify && sAccount.length!=11" plain size="small" type="primary" @click="showVerify = true">{{getBindText()}}</van-button>
			  </template>
			</van-field>
		</div>
		<div v-show="showVerify">
			<PhoneVerify :verifyType="verifyType" :mobile="phone" :verifyCount="verifyCount" @changeType="changeType" @back="aftVerify"></PhoneVerify>
			<Notes :hasPhone="phone && phone.length == 11"></Notes>
		</div>
		
		<van-overlay :show="showCode" @click="showCode = false" />
		
		<div class = "code-div" v-show="showCode">
			<van-password-input :value="code" length="6" :mask="false"  :gutter="10" :focused="showKeyboard" @focus="showKeyboard = true" />
		    <div class = "code-btn-div">
			   <van-button round v-if="!code" @click="getCode()" :disabled="codeMsg != '获取短信验证码'" type="primary">{{codeMsg}}</van-button>
			   <van-button round v-if="code" @click="changeBind()" :disabled="code.length != 6" type="primary">确认</van-button>
			</div>
		</div>
		
		<!-- 数字键盘 -->
		<van-number-keyboard  v-model="code" :show="showKeyboard" @blur="showKeyboard = false" />
	</div>
</template>

<script>
	import { smsSend,relieveBound,bound } from '@/request/api';
	import Card from '../components/recharge/Card.vue'
	import ComNar from '../components/searchShop/ComNar.vue'
	import PhoneVerify from '../components/phoneVerify/PhoneVerify.vue'
	import Notes from '../components/phoneVerify/Notes.vue'
	import {Field,Cell,Button,PasswordInput,NumberKeyboard,Overlay,Notify} from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'userInfo',
		computed: mapGetters(["sUserInfo","sAccount"]),
		components: {
		      [Field.name]: Field,
		      [Cell.name]: Cell,
		      [ComNar.name]: ComNar,
		      [Card.name]: Card,
		      [Button.name]: Button,
		      [PasswordInput.name]: PasswordInput,
		      [NumberKeyboard.name]: NumberKeyboard,
		      [Overlay.name]: Overlay,
		      [Notify.name]: Notify,
		      [PhoneVerify.name]: PhoneVerify,
		      [Notes.name]: Notes
		 },
		data(){
			return {
				verifyCount:0,
				verifyType:0,
				showVerify:false,
				showCode:false,
				showKeyboard:false,
				codeMsg:'获取短信验证码',
				phone:'',
				oldPhone:'',
				code:'',
				codeTime:60,
				codeTimer:''
				
			}
		},
		created() {
			this.getPhone();
		},
		methods:{
			...mapMutations(['sRemovePhone','sSetPhone']),
			changeType(type){
				this.verifyType = type
				if(type == 2){
					this.showCode = true
					if(this.codeMsg == '获取短信验证码'){
						this.getCode()
					}
				}else{
					this.showCode = false
					this.code = ''
					this.verifyCount ++
				}
			},
			aftVerify(){
				this.changeBind()
			},
			getPhone(){
				this.oldPhone = this.sUserInfo.mobile;
				this.phone = this.sUserInfo.mobile;
			},
			getBindText(){
				if(this.oldPhone){
					return '解绑';
				}else{
					return '绑定';
				}
			},
			//获取验证码
			getCode(){
				let phone = this.phone;
				//发送短信
				if(phone.length != 11){
					this.showCode = false;
					Notify({ type: 'danger', message: '手机号格式错误' });
				}else{
					//开启定时器
					this.codeMsg = this.codeTime + "秒后重试";
					this.codeTimer = setInterval(this.reduceTime, 1000);
					this.sendCode(phone);
				}
				
			},
			//axios获取验证码
			sendCode(phone){
				smsSend({
					mobile:	phone	  
				}).then(res => {
					Notify({ type: 'success', message: '验证码已发送' });					  
				}) 
			},
			changeBind(){
				if(this.oldPhone){
					this.unbind()
				}else{
					this.bind()
				}
			},
			unbind(){
				relieveBound({
					mobile:this.phone,
					code:this.code
				}).then(res => {
					this.oldPhone = ''
					this.verifyCount = 0
					this.verifyType = 0
					this.showVerify = false
					this.phone  = '';
					this.code  = '';
					this.showCode = false;
					this.stopCodeTimer();
					Notify({ type: 'success', message: '请绑定新的手机号' });					  
				}) 
			},
			bind(){
				bound({
					mobile:	this.phone,
					code:this.code
				}).then(res => {
					this.sSetPhone(this.phone);
					this.oldPhone = this.phone
					this.verifyCount = 0
					this.verifyType = 0
					this.showVerify = false
					this.code  = '';
					this.showCode = false;
					this.stopCodeTimer();
					Notify({ type: 'success', message: '操作成功' });					  
				}) 
			},
			hasPhone(){
				if(this.oldPhone){
					return true
				}else{
					return false
				}
			},
			//定时器-验证码
			reduceTime(){
				this.codeTime --;
				if(this.codeTime == 0){
					this.stopCodeTimer();
				}else{
					this.codeMsg = this.codeTime + "秒后重试";
				}
				
			},
			
			stopCodeTimer(){
				clearInterval(this.codeTimer);
				this.codeTime = 60;
				this.codeMsg = "获取短信验证码";
			}
			
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		background-color: #f5f5f5;
	}
	
	.user-info-div {
		padding-top: 15px;
		
	}
	
	.user-info-div /deep/ .van-field__label {
		color:#373737
	}
	
	.user-info-div .an-cell__title {
		color: #2d2d2d;
		font-size: 15px;
	}
	
	.user-info-div .van-button {
		width: auto;
		height: auto;
		margin: 0;
		padding: 6px 15px;
		font-size: 13px;
	}
	
	.code-div {
		position: fixed;
		width: 100%;
		top: 160px;
		left: 0px;
		z-index: 10;
	}
	
	.code-div .van-password-input__item {
		border-radius: 5px;
		/* background: rgba(0,0,0,0.2);
		border: #ffffff 1px solid;
		color: #ffffff; */
	}
	
	.code-btn-div {
		padding: 30px 20px;
	}
	
	.code-btn-div>button {
		width: 100%;
		height: 50px;
		padding: 4px;
	}
	
	.code-btn-div>button .van-button__content {
		font-size: 15px;
	}
	
	.van-overlay {
		background-color: rgba(0,0,0,0.8);
	}
</style>
